import postAPI from './postAPI.js'

export default async function postLinkToAgreement(body) {
    const data = await postAPI('admin/taskinstances/linktoagreement', body);
    return data;
}
